import React from 'react';
import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

const AddressSection = ({ address, city, state, zipcode }) => {
  return (
    <Stack spacing={1} sx={{ px: 2 }}>
      <Typography sx={{ fontSize: 16, fontWeight: 300 }} variant="subtitle1">
        Address
      </Typography>
      <Stack>
        <Typography variant="subtitle2">{address}</Typography>
        <Typography variant="subtitle2">
          {city}, {state} {zipcode}
        </Typography>
      </Stack>
    </Stack>
  );
};

AddressSection.propTypes = {
  address: PropTypes.string.isRequired,
  city: PropTypes.string.isRequired,
  state: PropTypes.string.isRequired,
  zipcode: PropTypes.string.isRequired,
};

export default AddressSection;
